<template>
  <form
    class="coupon text-center d-inline-block align-top"
    v-on:click="handleClick"
    :class="{'coupon--applyed': coupon}"
    v-on:submit.prevent="$refs['coupon-input'].blur()"
  >
    <span class="applyed-icon" v-if="coupon"></span>
    <input
      v-if="isEdit"
      v-on:blur="handleBlur"
      type="text"
      class="form-control text-center"
      ref="coupon-input"
      :value="coupon"
    />
    <div v-else class="coupon__info rounded">
      <b>{{coupon || 'Apply coupon'}}</b>
    </div>
    <LoadingShadow v-if="loading" />
  </form>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import LoadingShadow from '../elements/LoadingShadow'

export default {
  data() {
    return {
      isEdit: false
    }
  },
  components: {
    LoadingShadow
  },
  computed: {
    ...mapGetters('payment', ['coupon', 'loading'])
  },
  methods: {
    ...mapActions('payment', ['applyCoupon']),
    handleClick() {
      this.isEdit = true
      this.$emit('editing', true)
      setTimeout(() => {
        this.$refs['coupon-input'].focus()
      }, 100)
    },
    async handleBlur(event) {
      this.isEdit = false
      const value = event.target.value
      if (value && value !== this.coupon) {
        this.$emit('applying', true)
        await this.applyCoupon(value)
        this.$emit('applying', false)
      }
      this.$emit('editing', false)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../style/variables';

.coupon {
  position: relative;
  width: 100%;
  &__info {
    border: 1px dashed $secondary;
    padding: $input-btn-padding-y $input-btn-padding-x;
    height: $input-height;
    background-color: rgba($secondary, 0.1);
    color: $secondary;
    cursor: pointer;
    &:hover {
      background-color: rgba($secondary, 0.2);
    }
  }
  &--applyed {
    .coupon__info {
      border-color: $theme;
      background-color: rgba($theme, 0.1);
      color: $theme;
    }
  }
  .form-control {
    border-color: $secondary;
  }
}
.applyed-icon {
  $icon-size: 1.2rem;
  background-color: $theme;
  position: absolute;
  right: $icon-size/2;
  top: 50%;
  margin-top: -$icon-size/2;
  width: $icon-size;
  height: $icon-size;
  border-radius: 50%;
  display: inline-block;
  &:after {
    content: '';
    position: absolute;
    left: calc(50% - #{$icon-size/6});
    top: calc(50% - #{$icon-size/1.8});
    width: $icon-size/3;
    height: $icon-size/1.5;
    box-shadow: $icon-size/10 $icon-size/10 0 0 #fff;
    transform: rotate(45deg);
  }
}
</style>
